module.exports = __webpack_public_path__ + "img/video.4a061204.png";